import { useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {  Box, Button, Container, Typography, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, TextField,} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { callPostApi, callShopviewPostApi, } from "../../components/API/ApiCallFunction";
import { Add, AddPhotoAlternateOutlined, Info,} from "@mui/icons-material";
import Status from "./StatusChip";
import ImagePreview from "../CommanComponents/ImagePreview";
import FullImgPreview from "../CommanComponents/FullImgPreview";
import GradientLoader from "../CommanComponents/GradientLoader";
import DialogBox from "../CommanComponents/DialogBox";
import InfoPopover from "../CommanComponents/InfoPopover";
import { toast } from 'react-toastify';




export default function CouponList() {
  const [filterLimit, setFilterLimit] = useState(100);
  const navigate = useNavigate();
  const [datar, setDatar] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [opend, setOpend] = useState(false);
  const [offerId, setOfferId] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const isMobile = useMediaQuery("(max-width:768px)");
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [imageFile, setImageFile] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const handleImageChange = async (e) => {
    const { files } = e.target;
    const file = files[0];
    try { setImageFile(file); setImagePreview(URL.createObjectURL(file));
      
    } catch (err) { }};

    //Coupon List Api
  const couponListApi = async () => {
    try {
      setLoading(true);
      const storeid = user.store_info.store_id;
      const payload = { mod: "CASHI_OFFER_LIST", data_arr: { store_id: storeid, start: 0, limit: filterLimit, }, };
      const apiResult = await callPostApi("cashi-offer", payload);
      if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
        const formattedData = apiResult.data.map((item, index) => ({
          id: index + 1,
          offerId: item.offer_id || "NA",
          ctitle: item.offer_title || "NA",
          generate: item.max_coupon || "NA",
          issued: item.coupon_issued || "0",
          minorder: item.min_order_amount || "NA",
          cvalue: item.coupon_coin || "NA",
          redemption: item.redemption_bid || "NA",
          distributionBid: item.distribution_bid || "NA",
          shortd: item.short_desc || "NA",
          longd: item.long_desc || "NA",
          activedate: item.offer_active || "NA",
          dateadded: item.date_added || "NA",
          expdate: item.offer_expire || "NA",
          offimg: item.offer_image || "NA",
          status: "1" ? "Approved" : "Pending",
        }));
        setDatar(formattedData);
      } else {  setDatar([]);}
    } catch (err) { } 
      finally { setLoading(false); } };

  useEffect(() => {
    window.dispatchEvent(new Event('refreshWalletAmount'));
    couponListApi();
  }, []);

  //image
  // Handlers

 const compressAndConvertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Calculate new dimensions while maintaining aspect ratio
        let width = img.width;
        let height = img.height;
        const maxSize = 800; // Max width/height
        
        if (width > height && width > maxSize) {
          height = (height * maxSize) / width;
          width = maxSize;
        } else if (height > maxSize) {
          width = (width * maxSize) / height;
          height = maxSize;
        }
        canvas.width = width;
        canvas.height = height;
        // Draw image on canvas with new dimensions
        ctx.drawImage(img, 0, 0, width, height);
        
        // Get compressed base64 string
        const compressedBase64 = canvas.toDataURL('image/jpeg', 0.6); // Adjust quality (0-1)
        
        // Remove data:image/jpeg;base64, prefix
        const base64Data = compressedBase64.split(',')[1];
        // Check file size (base64 string length * 0.75 gives approximate file size in bytes)
        const approximateFileSize = Math.round((base64Data.length * 0.75) / 1024); // in KB
        
        if (approximateFileSize > 500) {
          reject(new Error('Compressed image is still larger than 500KB'));
          return;
        }
        
        resolve(base64Data);
      };
      
      img.onerror = (error) => reject(error);
    };
    
    reader.onerror = (error) => reject(error);
  });
};

  // Api
  const handleImageSave = async () => {
     if (!imageFile) {
           toast.error('Please select the image');
         return;
       }
    try {
      const base64Data = await compressAndConvertToBase64(imageFile);
      setLoading(true);
      const storeid = user.store_info.store_id;
      const payload = { mod: "UPDATE_CASHI_OFFER_IMAGE", data_arr: { store_id: storeid, offer_id: offerId,
                        offerImage: { file_name: imageFile.name, file_data: base64Data,}, }, };
      const apiResult = await callShopviewPostApi("cashi-offer", payload);

      if (apiResult.status === "200" && apiResult.data) {
        toast.success("Image updated successfully!"); 
        setTimeout(() => {
        setOpend(false);
        setImageFile("");
        setImagePreview(null);
         if (fileInputRef.current) fileInputRef.current.value = "";
        couponListApi();
      }, 300);
      } else {
        toast.error(apiResult.data);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

 const clearImageFields = () => {
  setImageFile("");
  setImagePreview(null);
  if (fileInputRef.current) fileInputRef.current.value = "";
};
 

  const columns = [
    { field: "id", headerName: "Sr no.", flex: isMobile ? undefined : 0.7, align: "center", },
    { field: "ctitle", headerName: "Coupon Title", flex: isMobile ? undefined : 1.7, },
    { field: "offimg", headerName: "Coupon Image", flex: isMobile ? undefined : 1,
       renderCell: (params) => { if (!params.value || params.value === "NA") { return <Typography variant="body2">No Image</Typography>; }
          return <FullImgPreview src={params.value} />;  }, },
    { field: "generateIssued", headerName: "Issued/Generated", flex: 1.5, align: "center", 
      renderCell: (params) => `${params.row.issued} /${params.row.generate} `, },
    { field: "minorder", headerName: "Minimum Order Amount", flex: 1.5, align: "center", },
    { field: "dateadded", headerName: "Date Added", flex: 1, align: "center",},
    { field: "status",  headerName: "Status", flex: 1, minWidth: 140, renderCell: (params) => <Status status={params.value} />,},
    { field: "Action", headername: "Action", flex: 1, minWidth: 140,  align: "center",
      renderCell: (params) => (
        <>
          <Info sx={{ color: "#1A73E8", cursor: "pointer" }}
            onClick={() => { setSelectedRow(params.row); setOpen(true);}} />
          
          <AddPhotoAlternateOutlined
            sx={{ color: "#1b8393ff" }}
            onClick={() => { setOpend(true); setSelectedRow(params.row); setOfferId(params.row.offerId); }} />
        </>
      ),
      // <Button onClick={() => {
      //       setSelectedRow(params.row); // store row
      //     setOpen(true);              // open dialog
      //    }}><Info /></Button>
    },
  ];

  return (
    <Container sx={{ my: 2 }}>
      {loading && <GradientLoader text="Loading" />} {/* // loader */}
      {/* Back Button */}
      <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
        <Button variant="contained" sx={{ backgroundColor: "#000000", color: "#ffffff" }} onClick={() => navigate(-1)} >
          Back
        </Button>
      </Box>
      {/* Title */}
      <Typography  variant="h6" gutterBottom
        sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)", p: 1, color: "#ffffff",
          borderRadius: "4px", mb: 3, display: "flex", alignItems: "center", }} >
        Coupon List
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button variant="contained"  sx={{ background: "linear-gradient(195deg, #49a3f1, #1A73E8)", color: "#ffffff", }}
          onClick={() => navigate("/createcoupon")} >
          <Add /> Create Coupon
        </Button>
      </Box>
      <Box sx={{my:2}}>
        <TextField  select label="Limit" value={filterLimit} onChange={(e) => { setFilterLimit(e.target.value);}}
          sx={{ minWidth: 140, }}>
          <MenuItem value={100}>100</MenuItem>
            <MenuItem value={300}>300</MenuItem>
            <MenuItem value={500}>500</MenuItem>
            <MenuItem value={2000}>All</MenuItem>
        </TextField>
        <Button  variant="outlined" color="primary"  sx={{ height: 56 , mx:1}} onClick={() => { couponListApi();}}>
          Apply Filter
        </Button>
      </Box>
      {/* DataGrid */}
      <Box sx={{ height: "auto", width: "100%", mb: 4 }}>
        <DataGrid  rows={datar}  columns={columns} disableRowSelectionOnClick showToolbar
          getRowHeight={() => "auto"} pageSizeOptions={[ 10, 25, 50]} initialState={{ pagination: { paginationModel: { pageSize: 10,}, },
        }}
          sx={{
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal", // Allow wrapping
              lineHeight: "20px",
              wordBreak: "break-word",
              display: "flex",
              alignItems: "center", // Vertically center content
              padding: "5px",
              gap: "4px",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: 14,
              fontWeight: "600",
              whiteSpace: "normal",
              wordBreak: "break-word",
            },
            "& .css-1825rpx-MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer":
              {
                justifyContent: "center",
              },
          }}
        />
      </Box>

      <Dialog  open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth  sx={{ overflowY: "auto" }} >
        <Box>
          {selectedRow ? (
            <>
              <DialogTitle  sx={{  background: "linear-gradient(195deg, #49a3f1, #1A73E8)", color: "#fff", }}  >
                {selectedRow.ctitle}
              </DialogTitle>
              <DialogContent>
                <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}>
                  <b>Coupon Value:</b> {selectedRow.cvalue}
                </Typography>
                <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}>
                  <b>Redemption Value:</b> {selectedRow.redemption}
                </Typography>
                <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}>
                  <b>Short Description:</b> {selectedRow.shortd}
                </Typography>
                <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}>
                  <b>Long Description:</b> {selectedRow.longd}
                </Typography>
                <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}>
                  <b>Active Date:</b> {selectedRow.activedate}
                </Typography>
                <Typography sx={{ borderBottom: "1px solid #eee", py: 1 }}>
                  <b>Expiry Date:</b> {selectedRow.expdate}
                </Typography>
                <Typography sx={{  py: 1 }}>
                  <b>Coupon Image:</b> 
                </Typography>
                {selectedRow.offimg && selectedRow.offimg !== "NA" && ( <Box mt={2}>  <ImagePreview src={selectedRow.offimg} /> </Box> )}
              </DialogContent>
              <DialogActions>
                <Box sx={{ textAlign: "right", mt: 2 }}>
                  <Button onClick={() => setOpen(false)} variant="contained">  Close </Button>
                </Box>
              </DialogActions>
            </>
          ) : (
            <Typography>No details available</Typography>
          )}
        </Box>
      </Dialog>
      <DialogBox  open={opend}  onClose={() => setOpend(false)}  title="Upload Image" >
        <Box item size={{ xs: 12, sm: 12, md: 6 }}>
          <Typography sx={{ display: "flex", alignItems: "center" }}>  Offer Artwork
            <InfoPopover title="Offer Artwork "
              description="This image will be displayed on the Cashi App. For optimal resolution, use a 1x1 aspect ratio in PNG format" />
          </Typography>
          <Button variant="outlined" component="label">
            {imageFile ? imageFile.name : "Upload Image"}
            <input type="file" accept="image/*" ref={fileInputRef}  hidden onChange={handleImageChange} />
          </Button>

          {imagePreview && (
            <Box sx={{ mt: 2 }}>
              <img  src={imagePreview} alt="Preview"
                style={{ width: "100%",  maxHeight: "200px", objectFit: "contain", border: "1px solid #ccc",  borderRadius: "8px", }}  />
            </Box>
          )}
        </Box>
        <DialogActions>
          <Button onClick={() => {setOpend(false); clearImageFields();}} variant="outline"> Close </Button>
          <Button onClick={() => handleImageSave()} variant="contained">  Save </Button>
        </DialogActions>
      </DialogBox>

    </Container>
  );
}
